<!-- eslint-disable vue/no-unused-vars -->
<template>
  <section v-bind="$attrs">
    <div class="inline-flex items-center gap-4">
      <ambi-advanced-filter-price />
      <ambi-advanced-filter-date />
    </div>
  </section>

  <div class="FiltersOverlay -Closed" ref="overlay"></div>
</template>

<script>
import { ref, provide } from 'vue'
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'
// import { selectedFilters } from './filtersStorage'

export default {
  props: {
    insideStickyPanel: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const breakpoints = useBreakpoints(breakpointsTailwind)
    const isMobile = breakpoints.smaller('lg')
    const overlay = ref(null)

    const onShow = () => {
      if (isMobile.value) {
        document.body.classList.add('AdvancedFilterOpenedOnMobile')
        overlay.value.classList.remove('-Closed')
      }
    }
    const onHide = () => {
      if (isMobile.value) {
        document.body.classList.remove('AdvancedFilterOpenedOnMobile')
        overlay.value.classList.add('-Closed')
      }
    }

    // provider
    provide('onShow', onShow)
    provide('onHide', onHide)
    provide('insideStickyPanel', props.insideStickyPanel)

    return { onShow, onHide, isMobile, overlay }
  }
}
</script>

<style lang="scss">
.FiltersOverlay {
  @apply fixed inset-0 bg-black bg-opacity-50;

  z-index: 70; // nejvyssi prvek na strance hlavicka ma 50

  &.-Closed {
    @apply hidden;
  }
}

.AdvancedFilterOpenedOnMobile {
  .DropdownAmbi,
  .DropdownAmbi[style] {
    position: fixed !important;
    bottom: 1rem !important;
    top: auto !important;

    /* [1] design without edge */
    // left: 50% !important;
    // right: 50% !important;
    // transform: translateX(-50%) !important;

    /* [2] design with gap from left and right */
    left: 1rem !important;
    right: 1rem !important;
    transform: translateX(0) !important;
    max-width: calc(100% - 2rem) !important;
  }

  .Beak {
    display: none !important;
  }
}

.Beak {
  content: '';
  height: 20px;
  width: 20px;
  background-color: #fff;
  transform: rotate(45deg);
  position: relative;
}

.Beak.-Top {
  top: 7px;
  border-top: theme('colors.divider-dark') solid 2px;
  border-left: theme('colors.divider-dark') solid 2px;
  @apply invisible;
}

.Beak.-Bottom {
  bottom: 7px;
  border-bottom: theme('colors.divider-dark') solid 2px;
  border-right: theme('colors.divider-dark') solid 2px;
  @apply invisible;
}

[data-popper-placement='bottom-end'],
[data-popper-placement='bottom-start'] {
  .Beak.-Top {
    @apply visible;
  }
}

[data-popper-placement='top-end'],
[data-popper-placement='top-start'] {
  .Beak.-Bottom {
    @apply visible;
  }
}
</style>
